import { render, staticRenderFns } from "./ModalList.vue?vue&type=template&id=208a03ce&"
import script from "./ModalList.vue?vue&type=script&lang=ts&"
export * from "./ModalList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports